var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuVitamins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4l1.3-1.625A1 1 0 0110.081 2h3.839a1 1 0 01.781.375L16 4v1a1 1 0 01-1 1H9a1 1 0 01-1-1V4v0zM9.667 9.333L8 11l-1-1M13 10h3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 20H6a2 2 0 01-2-2V6a2 2 0 012-2h2M16 4h2a2 2 0 012 2v2M18.262 15.167h-1.167V14a2 2 0 012-2h1.167v1.167a2 2 0 01-2 2zM16.999 22c-2.21 0-4.001-1.748-4.001-3.905M12.998 18.095c0-1.704.8-2.929 2.401-2.929M16.999 22C19.209 22 21 20.252 21 18.095M21 18.095c0-1.704-.8-2.929-2.401-2.929M18.599 15.167c-.8 0-1.254.25-1.6.25-.346 0-.8-.25-1.6-.25M7 15h3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  })));
}
export default SvgMenuVitamins;


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu-vitamins.svg
// module id = 779
// module chunks = 13